






























































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import VerkInvoiceAccList from "../verkViews/VerkInvoiceAccList.vue";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { verkInvoiceStatusColor } from "../verkViews/verkInvoiceStatus";

/**
 * Egy belső számla (prefix + azonosító) összes Verk vezérrekordja (hmifcapiverkinv) — a tárolt eljárás
 * minden futásának eredménye, újabb → régebbi sorrendben, a CarHistory mintájára. A főlistán csak a
 * legutolsó futás látszik, itt a korábbiak hibaüzenete és kontírozása is visszanézhető.
 */
interface Props {
  /** DLM belső számla prefix (pl. GENO) */
  invCode: string;
  /** DLM belső számla azonosító (hmouigeninvoice.szam) */
  invNo: number;
}

interface Methods {
  statusColor(status: number): string;
  /** Könyvelési időszak megjelenítése: ÉÉÉÉ/HH */
  periodDisplay(item: any): string;
}

interface Computed {
  url: string;
  apiSearchName: string;
  columns: any[];
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "VerkInvoiceHistory",

  components: {
    ApiSearchPage,
    IconButton,
    DateTimeDisplay,
    SyncStatusBadge,
    VerkInvoiceAccList,
  },

  props: {
    invCode: { type: String, default: "" },
    invNo: { type: Number, default: 0 },
  },

  computed: {
    url(): string {
      return `iface-sync-verk-invoice/history-search/${encodeURIComponent(this.invCode)}/${this.invNo}`;
    },

    apiSearchName(): string {
      return `VerkInvoiceHistoryApiSearch_${this.invCode}_${this.invNo}`;
    },

    columns(): any[] {
      return [
        { field: "selected", title: "", cell: "command", filterable: false, sortable: false, width: 50 },
        { field: "insDateTime", title: "Időpont", width: 110, filterable: false, cell: "insDateTime" },
        { field: "statusName", title: "Státusz", width: 140, cell: "statusName", filterable: false },
        { field: "customerNo", title: "Verk ügyfélszám", width: 120, type: ColumnType.Right, cell: "disabledText" },
        { field: "recDate", title: "Bizonylat kelte", width: 115, type: ColumnType.Date, filterable: false },
        { field: "accDate", title: "Könyvelés dátuma", width: 115, type: ColumnType.Date, filterable: false },
        { field: "dueDate", title: "Esedékesség", width: 115, type: ColumnType.Date, filterable: false },
        { field: "recYear", title: "Időszak", width: 80, cell: "period", filterable: false },
        { field: "origReceiptNo", title: "Eredeti számla", width: 150, cell: "disabledText" },
        { field: "accCount", title: "Bizonylatok", width: 110, cell: "accCount", filterable: false },
        { field: "errMsg", title: "Hibaüzenet", cell: "disabledText", fieldClass: "error-text-col" },
      ];
    },
  },

  methods: {
    statusColor(status) {
      return verkInvoiceStatusColor(status);
    },

    periodDisplay(item) {
      if (!item.recYear) return "";
      const month = String(item.recMonth ?? 0).padStart(2, "0");
      return `${item.recYear}/${month}`;
    },
  },
});
